import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import { Paper, Button, Chip, Divider, Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import RiwayatRaporMutu from './RiwayatRaporMutu';

const styles = theme => ({
    layoutRoot: {},
    pagingPeringkat: {
        textAlign: 'right'
    },
    tabSelected: {
        borderBottom: '5px solid #4EBAE7',
        background: '#ECEFF1',
        color: 'white'
    },
});

class RaporMutu extends Component {
    state = {
        error:0,
        routeParams:{
            jenis_rapor_id: 2
        },
        valueTab: 0,
        dialogBlocking: false,
        dialogTitle: (<span>Pemberitahuan</span>),
        dialogText: (<span>Menu Hitung Rapor Mutu belum dibuka untuk saat ini. Silakan lengkapi dan selesaikan pengisian instrumen kuesioner sekolah Anda terlebih dahulu.</span>),
        disableDialogButton: false
    }

    goTolink = (url) => {
        this.props.history.push(url);
    };

    componentDidMount = () => {
        this.props.setJudul('Hitung Rapor Mutu');

        localStorage.setItem('jenis_rapor_id',2);
    }

    handleChangeTab = (event, value) => {
        this.setState({
            valueTab: value
        });
    }

    onChangeJenisRapor = (e) => {
        localStorage.setItem('jenis_rapor_id', e.target.value);

        this.props.setLoading('block');

        this.setState({
            routeParams: {
                ...this.state.routeParams,
                jenis_rapor_id: e.target.value,
                pengguna_id: JSON.parse( localStorage.getItem('user') ).pengguna_id,
                sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id,
                token: localStorage.getItem('jwt_token'),
                tahun: localStorage.getItem('tahun'),
                instrumen_id: localStorage.getItem('instrumen_id'),
                start: 0
            }
        },()=>{
            this.props.getProsesRapor(this.state.routeParams).then((result)=>{
                // console.log(this.props.proses_rapor_mutu);
                this.props.setLoading('none');

                this.setState({
                    routeParams: {
                        ...this.state.routeParams,
                        tahun: localStorage.getItem('tahun'),
                        pengguna_id: JSON.parse( localStorage.getItem('user') ).pengguna_id,
                        sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id,
                        token: localStorage.getItem('jwt_token'),
                        instrumen_id: localStorage.getItem('instrumen_id'),
                        start: 0,
                        // jenis_rapor_id: localStorage.getItem('jenis_rapor_id'),
                        jenis_chart: 'radar_tahun'
                    }
                },()=>{
                    this.props.getRaporMutuRadar(this.state.routeParams).then((result)=>{
                        this.props.setDataTahun(result.payload);
                        // console.log(result.payload);
                        this.setState({
                            routeParams: {
                                ...this.state.routeParams,
                                jenis_chart: 'radar_wilayah'
                            }
                        },()=>{
                            this.props.getRaporMutuRadar(this.state.routeParams).then((result)=>{
                                this.props.setDataWilayah(result.payload);
                                // this.setState({
                                //     data_wilayah: this.props.rapor_mutu_radar
                                // });
                            });
                        });
                        
                        // this.setState({
                        //     data_tahun: this.props.rapor_mutu_radar
                        // },()=>{
                        //     this.setState({
                        //         routeParams: {
                        //             ...this.state.routeParams,
                        //             jenis_chart: 'radar_wilayah'
                        //         }
                        //     },()=>{
                        //         this.props.getRaporMutuRadar(this.state.routeParams).then((result)=>{
                        //             this.setState({
                        //                 data_wilayah: this.props.rapor_mutu_radar
                        //             });
                        //         });
                        //     });
                        // });
                    });
                });

            });
        });
        // console.log(e);
        // console.log(value);
        
    }

    handleCloseDialogBlocking = () => {
        this.setState({
            ...this.state,
            dialogBlocking: false,
            hideRapor: false
        })
    }

    handleCloseHitungRaporMutu = () => {
        this.props.history.push("/PerangkatKuesioner");
    }

    handleCloseBeranda = () => {
        this.props.history.push("/Beranda");
    }

    render()
    {
        const {classes} = this.props;
        
        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <FuseAnimate
                        animation="transition.slideRightBigIn"
                        duration={400}
                        delay={400}
                    >
                        <div style={{width: '100%', padding: 10}} className="konten-utama">
                            {/* <GhostList/>
                            <GhostList/>
                            <GhostList/>
                            <GhostList/> */}
                            {localStorage.getItem('hitung_aktif') === "0" &&
                            <Dialog
                                open={this.state.dialogBlocking}
                                // onClose={this.handleCloseDialogBlocking}
                                aria-labelledby="alert-rapor-mutu-belum"
                                aria-describedby="alert-rapor-mutu-belum"
                            >
                                <DialogTitle id="alert-rapor-mutu-belum-title">{this.state.dialogTitle}</DialogTitle>
                                <DialogContent>
                                <DialogContentText id="alert-rapor-mutu-belum-description">
                                    {this.state.dialogText}
                                </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                <Button onClick={this.handleCloseHitungRaporMutu} color="primary" autoFocus disabled={this.state.disableDialogButton}>
                                    Isi Kuesioner
                                </Button>
                                <Button onClick={this.handleCloseBeranda} color="primary" autoFocus disabled={this.state.disableDialogButton}>
                                    Kembali ke Beranda
                                </Button>
                                </DialogActions>
                            </Dialog>
                            }

                            <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                                <Chip
                                    icon={<HomeIcon/>}
                                    label=""
                                    className={this.props.classes.chip}
                                    color="primary"
                                    style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                    onClick={()=>{this.goTolink('/Beranda')}}
                                />
                                <Chip
                                    label={"> Hitung Rapor Mutu"}
                                    className={this.props.classes.chip}
                                    color="secondary"
                                    // onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                                    style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                                />
                            </div>
                            
                            <Paper className="p-16 m-8" style={{marginBottom:'10px'}}>
                                <Select
                                    value={this.state.routeParams.jenis_rapor_id}
                                    onChange={this.onChangeJenisRapor}
                                    style={{width:'100%'}}
                                    // input={
                                    // <OutlinedInput
                                    //     labelWidth={130}
                                    //     name="jenis_rapor_id"
                                    //     id="outlined-jenis_rapor_id"
                                    // />
                                    // }
                                >
                                    {/* <MenuItem value={1}>Rapor Tiga Responden</MenuItem> */}
                                    <MenuItem value={2}>Rapor Sekolah</MenuItem>
                                </Select>
                            </Paper>
                            <Paper className="m-8">
                                {/* <Tabs
                                    value={this.state.valueTab}
                                    onChange={this.handleChangeTab}
                                    variant="fullWidth"
                                    // style={{background:'#424242'}}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    >
                                    {/* <Tab label="Riwayat Penghitungan Rapor" classes={{ selected: classes.tabSelected }}/> */}
                                    {/* <Tab label="Hasil Rapor Mutu" classes={{ selected: classes.tabSelected }}/> */}
                                    {/* <Tab icon={<ListIcon />} label="Riwayat Proses Rapor" />
                                </Tabs> */}
                                <Divider/>
                                {/* {this.state.valueTab === 0 && */}
                                <div>
                                    <RiwayatRaporMutu />
                                </div>
                                {/* } */}
                                {/* {this.state.valueTab === 1 &&
                                <div className="p-16">
                                    <LembarRaporMutu/>
                                </div>
                                } */}
                            </Paper>

                        </div>
                    </FuseAnimate>
                }
            />
        )
    }

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSekolah: Actions.getSekolah,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getKemajuanTotal: Actions.getKemajuanTotal,
        getPeringkatPengisian: Actions.getPeringkatPengisian,
        setLoading: Actions.setLoading,
        setJudul: Actions.setJudul,
        getProsesRapor: Actions.getProsesRapor,
        getRaporMutuRadar: Actions.getRaporMutuRadar,
        setDataTahun: Actions.setDataTahun,
        setDataWilayah: Actions.setDataWilayah
    }, dispatch);
}

function mapStateToProps({ Sekolah, Instrumen }) {

    return {
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        kemajuan_total: Instrumen.kemajuan_total,
        peringkat_pengisian: Instrumen.peringkat_pengisian,
        proses_rapor_mutu: RaporMutu.proses_rapor_mutu,
        rapor_mutu_radar: RaporMutu.rapor_mutu_radar,
        data_tahun: RaporMutu.data_tahun,
        data_wilayah: RaporMutu.data_wilayah
    }
}

// export default withStyles(styles, {withTheme: true})(Beranda);
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(RaporMutu)));



// WEBPACK FOOTER //
// ./src/main/content/RaporMutu/RaporMutu.js